import { styled } from '@mui/material';

export const FormPopupSurface = styled('div')(
  {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
    width: 520,
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: 'calc(100vh - 48px)',
    padding: 28,
    overflowY: 'auto',
    borderRadius: 4,
  },
  ({ theme }) => ({
    direction: theme.RTL ? 'rtl' : 'ltr',
    backgroundColor: theme.palette.novotalk.$backgroundColor,
    color: theme.palette.novotalk.$textColorDarkBlue,
  }),
);

export const FormPopupTitle = styled('h2')({
  margin: 0,
  paddingRight: 32,
  fontSize: 24,
  lineHeight: 1.25,
});

export const FormPopupActions = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  gap: 12,
});
